(function () {
  'use strict';

  function getPaymentSource(host) {
    var section = host.closest('.ps-upliance-pdp-polish');
    return (section || document).querySelector('[data-emi-explorer]');
  }

  function getMonthlyAmount(host) {
    var paymentSource = getPaymentSource(host);
    var amountNode = paymentSource && paymentSource.querySelector('[data-emi-from]');
    var amount = amountNode ? amountNode.textContent.trim() : '';

    return /^\d[\d,]*$/.test(amount) ? amount : '';
  }

  function getLongestTenure(host) {
    var paymentSource = getPaymentSource(host);
    var tenures = paymentSource
      ? (paymentSource.dataset.tenures || '')
          .split(',')
          .map(function (tenure) { return parseInt(tenure.trim(), 10); })
          .filter(function (tenure) { return tenure > 0; })
      : [];

    return tenures.length ? Math.max.apply(Math, tenures) : 12;
  }

  function renderSticky(host, state, amount) {
    var section = host.closest('.ps-pdp-orange-theme');
    var sticky = section && section.querySelector('.product-sticky-cart');
    if (!sticky) return;

    sticky.querySelectorAll('[data-sticky-price-cycle-actual], [data-sticky-atc-actual]').forEach(function (display) {
      display.hidden = state !== 'actual';
    });
    sticky.querySelectorAll('[data-sticky-price-cycle-monthly], [data-sticky-atc-monthly]').forEach(function (display) {
      display.hidden = state !== 'monthly' || !amount;
    });
    sticky.querySelectorAll('[data-sticky-price-cycle-amount]').forEach(function (amountNode) {
      if (amount) amountNode.textContent = amount;
    });
  }

  function render(host) {
    var actualState = host.querySelector('[data-price-cycle-actual]');
    var monthlyState = host.querySelector('[data-price-cycle-monthly]');
    var amountNode = monthlyState && monthlyState.querySelector('[data-price-cycle-amount]');
    var tenureNode = monthlyState && monthlyState.querySelector('[data-price-cycle-tenure]');
    var toggle = host.querySelector('[data-price-cycle-toggle]');
    var note = host.querySelector('[data-price-cycle-note]');
    var amount = getMonthlyAmount(host);
    var state = host.dataset.priceCycleState === 'monthly' && amount ? 'monthly' : 'actual';

    if (amountNode && amount) amountNode.textContent = amount;
    if (tenureNode) tenureNode.textContent = String(getLongestTenure(host));
    if (actualState) actualState.hidden = state !== 'actual';
    if (monthlyState) monthlyState.hidden = state !== 'monthly';
    if (note) note.hidden = state !== 'monthly';
    if (toggle) {
      toggle.hidden = !amount;
      toggle.setAttribute('aria-pressed', state === 'monthly' ? 'true' : 'false');
      toggle.setAttribute(
        'aria-label',
        state === 'monthly' ? 'Show full product price' : 'Show monthly EMI estimate'
      );
    }

    host.dataset.priceCycleState = state;
    renderSticky(host, state, amount);
  }

  function initialize(host) {
    if (host.dataset.priceCycleInitialized === 'true') return;

    host.dataset.priceCycleInitialized = 'true';
    host.dataset.priceCycleState = 'monthly';
    render(host);

    document.addEventListener('variant:change', function () {
      render(host);
    });

    document.addEventListener('productInfo:loaded', function () {
      render(host);
    });
  }

  function initializeWithin(scope) {
    if (!scope) return;

    if (scope.matches && scope.matches('[data-price-cycle-host]')) initialize(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-price-cycle-host]').forEach(initialize);
    }
  }

  initializeWithin(document);
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-price-cycle-toggle]');
    var host = toggle && toggle.closest('[data-price-cycle-host]');
    if (!host || !getMonthlyAmount(host)) return;

    host.dataset.priceCycleState = host.dataset.priceCycleState === 'monthly'
      ? 'actual'
      : 'monthly';
    render(host);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();
